import React, { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';

import { ApiUrl, AppPages } from 'project/Defines.js';
import { EVENT_NAME, dispatchCustomEvent } from 'project/utilities';

import { T } from 'components/Translations';
import { Project } from 'project/Project';
import Translation from 'Shared/Translation';
import useDetail from 'Shared/useDetail';
import DetailView from 'Shared/DetailView';
import { FormField } from '../../../Shared/Form/formFields';
import { ValidationInput } from '../../../Shared/Form/validation';

/**
 * Country detail of setup
 * @exports Setup-CountryDetails
 */
export default function CountryDetails(props) {
    const { id } = useParams();
    const { windowKey, data } = props;
    const [translationValidation, setTranslationValidation] = useState({});
    const [translationValidationProps] = useState([{ lang: 'fr' }]);
    const listUpdateEvent = EVENT_NAME.SETUP_COUNTRY_LIST_UPDATE;
    const { isNew, dataItem, setDataItem, updateData, closePopup, onDetailDelete, detailRef, onChangeData, validation } = useDetail({
        data: data || { ID: id !== "create" ? id : null },
        updateUrl: ApiUrl.CountryUpdate,
        windowKey,
        dataLoadUrl: ApiUrl.CountryLoad,
        nameField: 'code',
        deleteUrl: ApiUrl.CountryDelete,
        backPage: AppPages.SetupCountries,
        listUpdateEvent,
        detailUrl: Project.getPageUrl(AppPages.SetupCountryDetails),
        validationFields: ["code"],
        externalValidation: translationValidation
    });

    const updateSuccessCallback = useCallback((response) => {
        if (detailRef.current) {
            setDataItem(response);
        }
        dispatchCustomEvent(listUpdateEvent, { action: 'update' });
        dispatchCustomEvent(EVENT_NAME.SETUP_COUNTRY_TRANSLATION_UPDATE, { ID: response.ID });
        closePopup();
    }, [setDataItem, closePopup, detailRef, listUpdateEvent]);

    return (<>
        {dataItem && <DetailView
            backUrl={Project.getPageUrl(AppPages.SetupCountries)}
            title={isNew ? <T>text.create_new_country</T> : dataItem.code}
        >
            <form>
                <div className='form_container'>
                    <div className='section_group'>
                        <div className='sections '>
                            <FormField label="text.code">
                                <ValidationInput validation={validation} autoComplete='off' name='code' type='text' value={dataItem.code} onChange={onChangeData} />
                            </FormField>
                        </div>
                    </div>
                    <div className='section_group'>
                        <div className='sections '>
                            <FormField label="text.translations">
                            </FormField>
                        </div>
                    </div>
                    <Translation
                        validation={translationValidation}
                        setValidation={setTranslationValidation}
                        validationProps={translationValidationProps}
                        ID={dataItem.ID}
                        fields={['nom']}
                        _class='App\Models\Context\Pays'
                        updateEvent={EVENT_NAME.SETUP_COUNTRY_TRANSLATION_UPDATE} />
                </div>
                <toolbar>
                    <wrap>
                        <action right=''>
                            <div onClick={(e) => updateData(updateSuccessCallback)} className='button'><icon>save</icon><T>text.save</T></div>
                            {dataItem.ID &&
                                <div className='button' onClick={(e) => {
                                    onDetailDelete(dataItem)
                                }}>
                                    <icon>delete</icon><T>text.delete</T>
                                </div>}
                        </action>
                    </wrap>
                </toolbar>
            </form>
        </DetailView>}
    </>);
}
